export default {
  path: 'permissions',
  name: 'PermissionsList',
  component: () => import('@/pages/sys_auth/permissions/PermissionsList'),
  meta: {title:'权限管理'}
}
